import { render, staticRenderFns } from "./menuApp.vue?vue&type=template&id=6734474a&scoped=true&"
import script from "./menuApp.vue?vue&type=script&lang=js&"
export * from "./menuApp.vue?vue&type=script&lang=js&"
import style0 from "./menuApp.vue?vue&type=style&index=0&id=6734474a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6734474a",
  null
  
)

export default component.exports